import Vue from 'vue'
import Router from 'vue-router'
import Main from '../view/Main'
import Error from '../view/Error'
Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/view/Login')
    },{
      path: '/apitest',
      name: 'apitest',
      component: () => import('@/view/apitest/ApiTest')
    },{
      path: '/visualization',
      name: 'visualization',
      component: () => import('@/view/home/Visualization')
    },
    {
      path: '/main',
      name: 'main',
      component: Main,
      children: [
        {
          path: '/home',
          name: 'home',
          meta: {
            title: '首页'
          },
          component: () => import('@/view/home/Index')
        },
        {
          path: 'feedback',
          name: 'feedback',
          component: () => import('@/view/Feedback/Feedback')
        }
      ],
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/tappinfo',
      name: 'tappinfo',
      meta: {
        requireAuth: true,
        title: "可信服务"
      },
      component: Main,
      children: [
        {
          path: 'appinfo',
          name: 'appinfo',
          meta: {
            title: "应用授权"
          },
          component: () => import('@/view/appinfo/appInfo')
        },{
          path: 'verifylog',
          name: 'verifylog',
          meta: {
            title: "调用日志"
          },
          component: () => import('@/view/verify/verifylog')
        },
      ]
    },
    {
      path: '/system',
      name: 'system',
      meta: {
        requireAuth: true,
        title: '系统管理'
      },
      component: Main,
      children: [
        {
          path: 'menu',
          name: 'menu',
          meta: {
            title: "菜单管理"
          },
          component: () => import('@/view/system/Menu')
        },
        {
          path: 'user',
          name: 'user',
          meta: {
            title: "用户管理"
          },
          component: () => import('@/view/system/User')
        },
        {
          path: 'role',
          name: 'role',
          meta: {
            title: "角色管理"
          },
          component: () => import('@/view/system/Role')
        },
        {
          path: 'right',
          name: 'right',
          meta: {
            title: "权限管理"
          },
          component: () => import('@/view/system/Right')
        },
        {
          path: 'ftp',
          name: 'ftp',
          meta: {
            title: "FTP管理"
          },
          component: () => import('@/view/system/Ftp')
        },
        {
          path: 'param',
          name: 'param',
          meta: {
            title: "参数管理"
          },
          component: () => import('@/view/system/Param')
        },
        {
          path: 'userrights',
          name: 'userrights',
          meta: {
            title: "用户权限"
          },
          component: () => import('@/view/system/UserRights')
        }
      ]
    },
    {
      path: '/assist',
      name: 'assist',
      meta: {
        requireAuth: true,
        title: "基础资料"
      },
      component: Main,
      children: [
        {
          path: 'country',
          name: 'country',
          meta: {
            title: "国家"
          },
          component: () => import('@/view/assist/Country')
        },
        {
          path: 'province',
          name: 'province',
          meta: {
            title: "省份"
          },
          component: () => import('@/view/assist/Province')
        },
        {
          path: 'city',
          name: 'city',
          meta: {
            title: "城市"
          },
          component: () => import('@/view/assist/City')
        },
        {
          path: 'region',
          name: 'region',
          meta: {
            title: "区县"
          },
          component: () => import('@/view/assist/Region')
        },
        {
          path: 'rightscode',
          name: 'rightscode',
          meta: {
            title: "权限码"
          },
          component: () => import('@/view/assist/RightsCode')
        }
      ]
    },
    {
      path: '/app',
      name: 'app',
      meta: {
        requireAuth: true,
        title: "APP管理"
      },
      component: Main,
      children: [
        {
          path: 'appupdate',
          name: 'appupdate',
          meta: {
            title: "APP升级"
          },
          component: () => import('@/view/app/Appupdate')
        },
        {
          path: 'appreg',
          name: 'appreg',
          meta: {
            title: "APP ID注册"
          },
          component: () => import('@/view/app/Appreg')
        }
      ]
    },
    {
      path: '/log',
      name: 'log',
      meta: {
        requireAuth: true,
        title: "系统日志"
      },
      component: Main,
      children: [
        {
          path: 'loginlog',
          name: 'loginlog',
          meta: {
            title: "登录日志查询"
          },
          component: () => import('@/view/log/Loginlog')
        },
        {
          path: 'operatelog',
          name: 'operatelog',
          meta: {
            title: "操作日志查询"
          },
          component: () => import('@/view/log/Operatelog')
        }
      ]
    },
    {
      path: '/error',
      name: 'error',
      component: Error
    },
    {
      path: '*',
      redirect: '/error',
      hidden: true
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js